import React from "react";
class Userc extends React.Component {
  render() {
    return (
      <div className="user-card">
        <h2>name:saqlain</h2>
        <h3>location:bbsr</h3>
        <h4>contact:-mdsaq07</h4>
      </div>
    )

  }
}
export default Userc;
//rest about class based component is written in the copy and some under the services.js
